export enum PassengerSexEnum {
  Male = "male",
  Female = "female",
}
